import { useEffect } from "react";
import { useGuideConfig, useNeuroState } from "@ignitesales/neuro-application";
import { ActionService } from '@ignitesales/neuro-application/src/neuro-guide/services/ActionService.mjs';
import { useActionTrigger } from "./useActionTrigger.mjs";

const useRecommendedProductActionTrigger = (products) => {
    const { customConfigs } = useGuideConfig();
    const { user } = useNeuroState();
    const { triggerAction } = useActionTrigger({
        contextData: { user, customConfigs: customConfigs?.guideActionServiceMapper }
    });

    useEffect(() => {
        const initialize = async () => {
            const actions = await ActionService.getActionsByTriggerType(
                "productRecommended"
            );

            const productIds = products
                .map((product) => product?.id)
                .filter((productId) => !!productId);

            const actionsToTrigger = actions
                .filter((action) =>
                    action.triggers.some(
                        (trigger) =>
                            trigger.type === "productRecommended" &&
                            (productIds.includes(trigger?.targetProductId) || !!trigger?.forAllProducts)
                    )
                )
                .map((action) => ({
                    ...action,
                    triggers: action.triggers.filter(
                        (trigger) =>
                            trigger.type === "productRecommended" &&
                            (productIds.includes(trigger?.targetProductId) || !!trigger?.forAllProducts)
                    ),
                }));

            await Promise.all(
                actionsToTrigger.map(async (action) => {
                    for (const trigger of action.triggers) {
                        // Use hook's triggerAction which handles pop/slide UI
                        await triggerAction(action, trigger, { user, customConfigs: customConfigs?.guideActionServiceMapper });
                        console.log(
                            "action " + action.name + " was triggered"
                        );
                    }
                })
            );
        };

        initialize();
    }, [products, user, customConfigs?.guideActionServiceMapper, triggerAction]);
};

export default useRecommendedProductActionTrigger;
